// extracted by mini-css-extract-plugin
export default {"toc":"TableOfContents_toc__bG9Sc","container":"TableOfContents_container__VwaGE","list":"TableOfContents_list__cAL89","link":"TableOfContents_link__bIQ4N"};